"use client";

import Image from "next/image";
import Reveal from "../../enterprise/components/Reveal";
import { motion } from "framer-motion";
import { useTranslations } from "next-intl";

export default function ConstitutionSection() {
  const t = useTranslations("governance");
  const data = [
    {
      content: t("transparency-in-every-transaction"),
      imgUrl: "/images/icons/gov1.png",
    },
    {
      content: t("sovereignty-of-data-and-compute"),
      imgUrl: "/images/icons/gov2.png",
    },
    {
      content: t("fair-distribution-of-rewards"),
      imgUrl: "/images/icons/gov3.png",
    },
    {
      content: t("open-and-permissionless-access"),
      imgUrl: "/images/icons/gov4.png",
    },
    {
      content: t("long-term-sustainability"),
      imgUrl: "/images/icons/gov5.png",
    },
  ];
  return (
    <section className="py-20">
      <div className="flex flex-col items-center justify-center">
        <Reveal
          delay={0.1}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <h2 className="max-w-[560px] text-center text-[48px]/[56px] tracking-[-1px] text-[#202020] max-lg:text-[32px]/[40px] max-sm:text-2xl">
            {t("a-constitution-for-the-digital-age")}
          </h2>
        </Reveal>
        <Reveal
          delay={0.5}
          duration={0.8}
          direction="left"
          withBlur={true}
          blurAmount={8}
        >
          <p className="mb-14 mt-6 max-w-[640px] text-center text-base/[24px] font-light text-[#646464]">
            {t(
              "at-the-heart-of-hyra-lies-its-digital-constitution-a-living-document-that-enshrines-community-rights-and-principles",
            )}
          </p>
        </Reveal>
      </div>

      <div className="flex flex-col items-center justify-center gap-[14px] max-lg:px-4">
        {data.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, translateY: 40 }}
            whileInView={{ opacity: 1, translateY: 0 }}
            transition={{ delay: 0.2 * index, duration: 1, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="mx-auto flex w-full sm:w-[688px] lg:w-[800px] items-center justify-between gap-4 rounded-[24px] border-[2px] border-[#E9F3FF] bg-[#F3F8FF61] p-6">
              <p className="text-[22px] tracking-[-0.5px] text-[#202020]">
                {item.content}
              </p>
              <Image
                src={item.imgUrl}
                alt={item.content}
                width={140}
                height={122}
              />
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
